module.exports = __webpack_public_path__ + "mainassets/img/menu-x.bec240c3.svg";